// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vaPage {
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;

  letter-spacing: 0;
}

/* Breadcrumb */
.vaBreadcrumb {
  font-size: 16px;
  color: var(--gris-terciaire);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 16px;
  padding-left: 12px;

  letter-spacing: 0;
}

.vaBreadcrumb .sep {
  color: var(--gris-principale);
}

.vaBreadcrumb .active {
  color: var(--couleur-principale);
  font-weight: 600;
}

.vaGrid {
  margin-top: 10px;
  /* pousse la grille vers le bas */
}


/* Main grid */
.vaGrid {
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 26px;
  align-items: start;
}

/* ====== GALLERY : mode GRILLE (<=3) ====== */
.vaGallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
}


.vaImgCard {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 8px rgba(0, 0, 0, .12);
  background: var(--white-principale);
}

/* Image plus longue (desktop/tablette) */
.vaImg {
  width: 100%;
  height: clamp(280px, 32vw, 380px);
  object-fit: cover;
  display: block;
}

/* ====== CAROUSEL (images > 3) ====== */
.vaCarousel {
  position: relative;
  min-height: clamp(280px, 32vw, 380px);
}

.vaCarouselTrack {
  position: relative;
  z-index: 1;

  display: flex;
  gap: 18px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding: 2px;
}

/* Masquer la scrollbar */
.vaCarouselTrack::-webkit-scrollbar {
  height: 0;
}

.vaCarouselTrack {
  scrollbar-width: none;
}

.vaCarouselTrack::-webkit-scrollbar-thumb {
  background: transparent;
}

/* 3 items visibles (desktop) */
.vaCarouselItem {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc((100% - 36px) / 3);
  scroll-snap-align: start;
}

/* Boutons gauche/droite */
.vaCarBtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 50;

  width: 42px;
  height: 42px;
  border: none;
  border-radius: 999px;

  background: rgba(0, 0, 0, .55);
  color: var(--white-principale);

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vaCarBtn:hover {
  background: rgba(0, 0, 0, .75);
}

.vaCarBtnLeft {
  left: 10px;
}

.vaCarBtnRight {
  right: 10px;
}

.vaCarBtn:disabled {
  opacity: .35;
  cursor: default;
}

/* ===== DETAILS SOUS IMAGES ===== */
.vaDetails {
  margin-top: 16px;
  letter-spacing: 0;
}

/* AUDI ... => 24px */
.vaTitle {
  font-size: 24px;
  font-weight: 700;
  color: var(--couleur-dark);
  margin-bottom: 10px;

  letter-spacing: 0;
}

/* XXX XXX XXX MGA => 20px */
.vaPrice {
  color: var(--couleur-secondaire);
  font-weight: 800;
  font-size: 20px;
  margin-bottom: 10px;

  letter-spacing: 0;
}

/* ANTANANARIVO => 16px */
.vaCity {
  font-size: 16px;
  color: var(--couleur-dark);
  margin-bottom: 8px;

  letter-spacing: 0;
}

/* 03/12/2025 à 14H56 => 16px + NOIR */
.vaDate {
  font-size: 16px;
  color: var(--couleur-dark);

  letter-spacing: 0;
}

/* ===== RIGHT ===== */
.vaRight {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.vaCard {
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);
  padding: 16px 16px 14px;
}

/* Les informations clés => 20px */
.vaCardTitle {
  color: var(--couleur-principale);
  font-weight: 700;
  font-size: 25px;
  margin-bottom: 14px;

  letter-spacing: 0;
}

.vaInfoList {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.vaInfoRow {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: baseline;
}

/* Clés rouges (Marque, Année...) => 12px */
.vaInfoKey {
  color: var(--couleur-secondaire);
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0;
}

/* Valeurs noires (AUDI, 2021...) => 14px */
.vaInfoVal {
  color: var(--couleur-dark);
  font-weight: 700;
  font-size: 14px;
  text-align: right;
  letter-spacing: 0;
  word-wrap: break-word;
  max-width: 50%;
}

/* Button */
.vaBtn {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 999px;

  background: var(--violet-principale);
  color: var(--white-principale);

  font-weight: 700;
  letter-spacing: 0;

  cursor: pointer;
  transition: background .15s ease, filter .15s ease;
}

/* hover rouge */
.vaBtn:hover {
  background: var(--couleur-secondaire);
  filter: none;
}

.info_icon_bootstrap {
  display: flex;
  flex-direction: row;
  gap: 5px;
}

/* ===== Responsive ===== */
@media (max-width: 992px) {
  .vaGrid {
    grid-template-columns: 1fr;
  }

  .vaRight {
    max-width: 420px;
  }

  .vaBreadcrumb {
    justify-content: flex-start;
  }

  /* carousel: 2 items visibles */
  .vaCarouselItem {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc((100% - 18px) / 2);
  }
}

@media (max-width: 720px) {
  .vaGallery {
    grid-template-columns: 1fr;
  }

  .vaImg {
    height: clamp(320px, 60vw, 420px);
  }

  .vaCarousel {
    min-height: clamp(320px, 60vw, 420px);
  }

  .vaCarouselItem {
    flex: 0 0 100%;
  }

  .vaCarBtn {
    width: 38px;
    height: 38px;
  }

  .vaCarBtnLeft {
    left: 8px;
  }

  .vaCarBtnRight {
    right: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/mes-annonces/MesAnnoncesVisualisation.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;;EAEpB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;;EAElB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;;AAGA,cAAc;AACd;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;;EAEV,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;;EAEX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;;EAEpB,8BAA8B;EAC9B,8BAA8B;;EAE9B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;;EAElB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,0BAA0B;;EAE1B,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;;EAEpB,oCAAoC;EACpC,8BAA8B;;EAE9B,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,kDAAkD;AACpD;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,+BAA+B;EAC/B;IACE,YAAiC;IAAjC,cAAiC;IAAjC,mCAAiC;EACnC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".vaPage {\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n\n  letter-spacing: 0;\n}\n\n/* Breadcrumb */\n.vaBreadcrumb {\n  font-size: 16px;\n  color: var(--gris-terciaire);\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  margin-bottom: 16px;\n  padding-left: 12px;\n\n  letter-spacing: 0;\n}\n\n.vaBreadcrumb .sep {\n  color: var(--gris-principale);\n}\n\n.vaBreadcrumb .active {\n  color: var(--couleur-principale);\n  font-weight: 600;\n}\n\n.vaGrid {\n  margin-top: 10px;\n  /* pousse la grille vers le bas */\n}\n\n\n/* Main grid */\n.vaGrid {\n  display: grid;\n  grid-template-columns: 1fr 320px;\n  gap: 26px;\n  align-items: start;\n}\n\n/* ====== GALLERY : mode GRILLE (<=3) ====== */\n.vaGallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 18px;\n}\n\n\n.vaImgCard {\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 1px 8px rgba(0, 0, 0, .12);\n  background: var(--white-principale);\n}\n\n/* Image plus longue (desktop/tablette) */\n.vaImg {\n  width: 100%;\n  height: clamp(280px, 32vw, 380px);\n  object-fit: cover;\n  display: block;\n}\n\n/* ====== CAROUSEL (images > 3) ====== */\n.vaCarousel {\n  position: relative;\n  min-height: clamp(280px, 32vw, 380px);\n}\n\n.vaCarouselTrack {\n  position: relative;\n  z-index: 1;\n\n  display: flex;\n  gap: 18px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  padding: 2px;\n}\n\n/* Masquer la scrollbar */\n.vaCarouselTrack::-webkit-scrollbar {\n  height: 0;\n}\n\n.vaCarouselTrack {\n  scrollbar-width: none;\n}\n\n.vaCarouselTrack::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n/* 3 items visibles (desktop) */\n.vaCarouselItem {\n  flex: 0 0 calc((100% - 36px) / 3);\n  scroll-snap-align: start;\n}\n\n/* Boutons gauche/droite */\n.vaCarBtn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 50;\n\n  width: 42px;\n  height: 42px;\n  border: none;\n  border-radius: 999px;\n\n  background: rgba(0, 0, 0, .55);\n  color: var(--white-principale);\n\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vaCarBtn:hover {\n  background: rgba(0, 0, 0, .75);\n}\n\n.vaCarBtnLeft {\n  left: 10px;\n}\n\n.vaCarBtnRight {\n  right: 10px;\n}\n\n.vaCarBtn:disabled {\n  opacity: .35;\n  cursor: default;\n}\n\n/* ===== DETAILS SOUS IMAGES ===== */\n.vaDetails {\n  margin-top: 16px;\n  letter-spacing: 0;\n}\n\n/* AUDI ... => 24px */\n.vaTitle {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--couleur-dark);\n  margin-bottom: 10px;\n\n  letter-spacing: 0;\n}\n\n/* XXX XXX XXX MGA => 20px */\n.vaPrice {\n  color: var(--couleur-secondaire);\n  font-weight: 800;\n  font-size: 20px;\n  margin-bottom: 10px;\n\n  letter-spacing: 0;\n}\n\n/* ANTANANARIVO => 16px */\n.vaCity {\n  font-size: 16px;\n  color: var(--couleur-dark);\n  margin-bottom: 8px;\n\n  letter-spacing: 0;\n}\n\n/* 03/12/2025 à 14H56 => 16px + NOIR */\n.vaDate {\n  font-size: 16px;\n  color: var(--couleur-dark);\n\n  letter-spacing: 0;\n}\n\n/* ===== RIGHT ===== */\n.vaRight {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.vaCard {\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0, 0, 0, .14);\n  padding: 16px 16px 14px;\n}\n\n/* Les informations clés => 20px */\n.vaCardTitle {\n  color: var(--couleur-principale);\n  font-weight: 700;\n  font-size: 25px;\n  margin-bottom: 14px;\n\n  letter-spacing: 0;\n}\n\n.vaInfoList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.vaInfoRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: baseline;\n}\n\n/* Clés rouges (Marque, Année...) => 12px */\n.vaInfoKey {\n  color: var(--couleur-secondaire);\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 0;\n}\n\n/* Valeurs noires (AUDI, 2021...) => 14px */\n.vaInfoVal {\n  color: var(--couleur-dark);\n  font-weight: 700;\n  font-size: 14px;\n  text-align: right;\n  letter-spacing: 0;\n  word-wrap: break-word;\n  max-width: 50%;\n}\n\n/* Button */\n.vaBtn {\n  width: 100%;\n  height: 40px;\n  border: none;\n  border-radius: 999px;\n\n  background: var(--violet-principale);\n  color: var(--white-principale);\n\n  font-weight: 700;\n  letter-spacing: 0;\n\n  cursor: pointer;\n  transition: background .15s ease, filter .15s ease;\n}\n\n/* hover rouge */\n.vaBtn:hover {\n  background: var(--couleur-secondaire);\n  filter: none;\n}\n\n.info_icon_bootstrap {\n  display: flex;\n  flex-direction: row;\n  gap: 5px;\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 992px) {\n  .vaGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .vaRight {\n    max-width: 420px;\n  }\n\n  .vaBreadcrumb {\n    justify-content: flex-start;\n  }\n\n  /* carousel: 2 items visibles */\n  .vaCarouselItem {\n    flex: 0 0 calc((100% - 18px) / 2);\n  }\n}\n\n@media (max-width: 720px) {\n  .vaGallery {\n    grid-template-columns: 1fr;\n  }\n\n  .vaImg {\n    height: clamp(320px, 60vw, 420px);\n  }\n\n  .vaCarousel {\n    min-height: clamp(320px, 60vw, 420px);\n  }\n\n  .vaCarouselItem {\n    flex: 0 0 100%;\n  }\n\n  .vaCarBtn {\n    width: 38px;\n    height: 38px;\n  }\n\n  .vaCarBtnLeft {\n    left: 8px;\n  }\n\n  .vaCarBtnRight {\n    right: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
